import { render, staticRenderFns } from "./DemandImage.vue?vue&type=template&id=7a84141a"
import script from "./DemandImage.vue?vue&type=script&lang=js"
export * from "./DemandImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports